import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkActionsBar = ({ selectedCount, onActivate, onDeactivate, onDelete, onClearSelection }) => {
  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[1000] bg-card border border-border rounded-lg shadow-lg p-4">
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-2 pr-4 border-r border-border">
          <Icon name="CheckSquare" size={20} color="var(--color-primary)" />
          <span className="text-sm font-medium text-text-primary">
            {selectedCount} {selectedCount === 1 ? 'item' : 'items'} selected
          </span>
        </div>

        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={onActivate}
            iconName="Eye"
            iconPosition="left"
            iconSize={14}
          >
            Activate
          </Button>

          <Button
            variant="outline"
            size="sm"
            onClick={onDeactivate}
            iconName="EyeOff"
            iconPosition="left"
            iconSize={14}
          >
            Deactivate
          </Button>

          <Button
            variant="destructive"
            size="sm"
            onClick={onDelete}
            iconName="Trash2"
            iconPosition="left"
            iconSize={14}
          >
            Delete
          </Button>

          <div className="w-px h-6 bg-border mx-2" />

          <Button
            variant="ghost"
            size="sm"
            onClick={onClearSelection}
            iconName="X"
            iconSize={14}
          >
            Clear
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkActionsBar;